import { render, staticRenderFns } from "./RowPerson.vue?vue&type=template&id=7228131a"
import script from "./RowPerson.vue?vue&type=script&lang=js"
export * from "./RowPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports